(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lady-bird-scroll-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbs-scroll-hero')) {
    class LbsScrollHero extends HTMLElement {
      connectedCallback() {
        this.introStage = this.querySelector(
          '[data-lbs-intro-stage]'
        );

        this.productStage = this.querySelector(
          '[data-lbs-product-stage]'
        );

        this.sticky = this.querySelector(
          '.lbs-scroll-hero__sticky'
        );

        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.stickyOffset =
          Number.parseFloat(this.dataset.stickyOffset || '0') || 0;

        this.frame = null;

        this.requestUpdate = this.requestUpdate.bind(this);
        this.update = this.update.bind(this);
        this.handleMotionChange =
          this.handleMotionChange.bind(this);

        window.addEventListener(
          'scroll',
          this.requestUpdate,
          { passive: true }
        );

        window.addEventListener(
          'resize',
          this.requestUpdate,
          { passive: true }
        );

        this.reducedMotion.addEventListener?.(
          'change',
          this.handleMotionChange
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(
            this.requestUpdate
          );

          this.resizeObserver.observe(this);
        }

        this.handleMotionChange();
      }

      disconnectedCallback() {
        window.removeEventListener(
          'scroll',
          this.requestUpdate
        );

        window.removeEventListener(
          'resize',
          this.requestUpdate
        );

        this.reducedMotion?.removeEventListener?.(
          'change',
          this.handleMotionChange
        );

        this.resizeObserver?.disconnect();

        if (this.frame) {
          window.cancelAnimationFrame(this.frame);
        }
      }

      clamp(value, minimum = 0, maximum = 1) {
        return Math.min(
          Math.max(value, minimum),
          maximum
        );
      }

      smoothStep(start, end, value) {
        const normalized = this.clamp(
          (value - start) /
            Math.max(end - start, 0.0001)
        );

        return (
          normalized *
          normalized *
          (3 - 2 * normalized)
        );
      }

      easeOutCubic(value) {
        return 1 - Math.pow(1 - value, 3);
      }

      handleMotionChange() {
        if (this.reducedMotion.matches) {
          this.style.setProperty(
            '--lbs-progress',
            '1'
          );

          this.style.setProperty(
            '--lbs-intro-opacity',
            '1'
          );

          this.style.setProperty(
            '--lbs-product-opacity',
            '1'
          );

          this.style.setProperty(
            '--lbs-intro-shift',
            '0px'
          );

          this.style.setProperty(
            '--lbs-product-copy-shift',
            '0px'
          );

          this.style.setProperty(
            '--lbs-product-media-shift',
            '0px'
          );

          this.style.setProperty(
            '--lbs-intro-image-scale',
            '1'
          );

          this.classList.add('is-product-active');

          this.introStage?.setAttribute(
            'aria-hidden',
            'false'
          );

          this.productStage?.setAttribute(
            'aria-hidden',
            'false'
          );

          if (this.introStage) {
            this.introStage.inert = false;
          }

          if (this.productStage) {
            this.productStage.inert = false;
          }

          return;
        }

        this.requestUpdate();
      }

      requestUpdate() {
        if (
          this.frame ||
          this.reducedMotion.matches
        ) {
          return;
        }

        this.frame = window.requestAnimationFrame(
          this.update
        );
      }

      update() {
        this.frame = null;

        const bounds = this.getBoundingClientRect();

        const stickyHeight =
          this.sticky?.offsetHeight ||
          window.innerHeight;

        const scrollableDistance = Math.max(
          this.offsetHeight - stickyHeight,
          1
        );

        const progress = this.clamp(
          (this.stickyOffset - bounds.top) /
            scrollableDistance
        );

        const introExit = this.smoothStep(
          0.2,
          0.58,
          progress
        );

        const productReveal = this.easeOutCubic(
          this.smoothStep(
            0.4,
            0.78,
            progress
          )
        );

        this.style.setProperty(
          '--lbs-progress',
          progress.toFixed(4)
        );

        this.style.setProperty(
          '--lbs-intro-opacity',
          (1 - introExit).toFixed(4)
        );

        this.style.setProperty(
          '--lbs-product-opacity',
          productReveal.toFixed(4)
        );

        this.style.setProperty(
          '--lbs-intro-shift',
          `${(introExit * 26).toFixed(2)}px`
        );

        this.style.setProperty(
          '--lbs-intro-image-scale',
          (
            1.015 +
            progress * 0.035
          ).toFixed(4)
        );

        this.style.setProperty(
          '--lbs-product-copy-shift',
          `${
            (1 - productReveal) * 76
          }px`
        );

        this.style.setProperty(
          '--lbs-product-media-shift',
          `${
            (1 - productReveal) * -76
          }px`
        );

        const productIsActive =
          productReveal > 0.68;

        const introIsActive =
          introExit < 0.68;

        this.classList.toggle(
          'is-product-active',
          productIsActive
        );

        if (this.productStage) {
          this.productStage.inert =
            !productIsActive;

          this.productStage.setAttribute(
            'aria-hidden',
            productIsActive
              ? 'false'
              : 'true'
          );
        }

        if (this.introStage) {
          this.introStage.inert =
            !introIsActive;

          this.introStage.setAttribute(
            'aria-hidden',
            introIsActive
              ? 'false'
              : 'true'
          );
        }
      }
    }

    customElements.define(
      'lbs-scroll-hero',
      LbsScrollHero
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ladybird-instagram-landing"] && !Shopify.designMode) return;
  try {
    
class LBLandingProduct {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-lb-product-form]');
    if (!this.form) return;
    this.variantInput = this.form.querySelector('[data-lb-variant-id]');
    this.addButton = this.form.querySelector('[data-lb-add]');
    this.addText = this.form.querySelector('[data-lb-add-text]');
    this.price = root.querySelector('[data-lb-price]');
    this.stickyPrice = root.querySelector('[data-lb-sticky-price]');
    this.stickyAdd = root.querySelector('[data-lb-sticky-add]');
    this.purchaseImage = root.querySelector('.lb-purchase__image');
    this.stickyImage = root.querySelector('.lb-sticky__image');
    this.sticky = root.querySelector('[data-lb-sticky]');
    this.purchaseMedia = root.querySelector('[data-lb-purchase-media]');
    this.purchaseSection = root.querySelector('[data-lb-purchase]');
    this.selectedColorLabel = root.querySelector('[data-lb-selected-color]');
    this.colorCards = [...root.querySelectorAll('[data-lb-color-card]')];
    this.soldoutState = root.querySelector('[data-lb-soldout-state]');
    this.soldoutTitle = root.querySelector('[data-lb-soldout-title]');
    this.soldoutHelper = root.querySelector('[data-lb-soldout-helper]');
    this.preorderButton = root.querySelector('[data-lb-preorder-button]');
    this.notifyPortal = root.querySelector('[data-lb-notify-portal]');
    this.notifyFallback = root.querySelector('[data-lb-notify-fallback]');
    this.purchaseFallbackSrc = this.purchaseImage ? this.purchaseImage.currentSrc || this.purchaseImage.src : null;
    this.stickyFallbackSrc = this.stickyImage ? this.stickyImage.currentSrc || this.stickyImage.src : null;
    this.variants = JSON.parse(this.form.querySelector('[data-lb-variants]').textContent);
    this.variantState = JSON.parse(this.form.querySelector('[data-lb-variant-state]').textContent);
    this.stateById = Object.fromEntries(this.variantState.map((item) => [String(item.id), item]));
    this.preorderVariants = JSON.parse(this.form.querySelector('[data-lb-preorder-variants]').textContent);
    this.variantMedia = JSON.parse(this.form.querySelector('[data-lb-variant-media]').textContent);
    this.mediaById = Object.fromEntries(this.variantMedia.map((item) => [String(item.id), item]));
    this.colorMedia = JSON.parse(this.form.querySelector('[data-lb-color-media]').textContent);
    this.optionGroups = [...this.form.querySelectorAll('[data-lb-option]')];
    this.colorOptionIndex = this.optionGroups.findIndex((group) => /colou?r/i.test(group.querySelector('legend')?.textContent || ''));
    this.form.addEventListener('change', () => this.onChange());
    if (this.stickyAdd) this.stickyAdd.addEventListener('click', () => this.handleStickyAction());
    if (this.preorderButton) this.preorderButton.addEventListener('click', () => this.addPreorder());
    if (this.notifyFallback) this.notifyFallback.addEventListener('click', () => this.openNotify());
    this.colorCards.forEach((card) => card.addEventListener('click', () => this.selectColor(card.dataset.colorName)));
    this.initStickyObserver();
    this.onChange();
  }

  selectedOptions() {
    return [...this.form.querySelectorAll('[data-lb-option]')].map((group) => {
      const selected = group.querySelector('[data-lb-option-input]:checked');
      return selected ? selected.value : null;
    });
  }

  onChange() {
    const selected = this.selectedOptions();
    const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    this.variantInput.value = variant.id;
    const formatted = this.formatMoney(variant.price);
    if (this.price) this.price.textContent = formatted;
    if (this.stickyPrice) this.stickyPrice.textContent = formatted;
    this.updateMedia(variant);
    if (this.colorOptionIndex >= 0 && this.selectedColorLabel) this.selectedColorLabel.textContent = variant.options[this.colorOptionIndex];
    this.updateAvailability(variant);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  isSoldOut(variant) {
    const state = this.stateById[String(variant.id)];
    if (!state) return !variant.available;
    const handle = this.root.dataset.productUrl || '';
    if (handle.includes('birdie-shirt')) return Number(state.inventory) <= 0;
    return state.available === false && Number(state.inventory) <= 0;
  }

  sizeName(size) {
    return ({ XS: 'Extra Small', S: 'Small', M: 'Medium', L: 'Large', XL: 'Extra Large' })[size] || size;
  }

  findPreorder(variant) {
    return this.preorderVariants.find((item) => item.options.every((value, index) => value === variant.options[index]));
  }

  updateSizeStates(variant) {
    const sizeIndex = this.optionGroups.findIndex((group) => /size/i.test(group.querySelector('legend')?.textContent || ''));
    if (sizeIndex < 0) return;
    const sizeGroup = this.optionGroups[sizeIndex];
    [...sizeGroup.querySelectorAll('[data-lb-option-input]')].forEach((input) => {
      const wanted = [...variant.options];
      wanted[sizeIndex] = input.value;
      const candidate = this.variants.find((item) => item.options.every((value, index) => value === wanted[index]));
      input.dataset.lbSoldout = candidate && this.isSoldOut(candidate) ? 'true' : 'false';
    });
  }

  updateAvailability(variant) {
    this.currentVariant = variant;
    this.updateSizeStates(variant);
    const soldOut = this.isSoldOut(variant);
    const preorder = soldOut ? this.findPreorder(variant) : null;
    this.currentPreorder = preorder || null;
    this.addButton.hidden = soldOut;
    this.addButton.disabled = soldOut || !variant.available;
    this.addText.textContent = this.root.dataset.addText || 'Add to cart';
    if (this.soldoutState) this.soldoutState.hidden = !soldOut;
    if (soldOut && this.soldoutTitle) {
      const size = variant.options.find((value, index) => /size/i.test(this.optionGroups[index]?.querySelector('legend')?.textContent || '')) || variant.options[1];
      this.soldoutTitle.textContent = `Size ${this.sizeName(size)} is currently out of stock`;
    }
    if (this.preorderButton) this.preorderButton.hidden = !preorder;
    if (this.soldoutHelper) this.soldoutHelper.hidden = !preorder;
    if (this.stickyAdd) {
      this.stickyAdd.textContent = soldOut ? (preorder ? 'Pre-order' : 'Notify me') : (this.root.dataset.addText || 'Add to cart');
    }
  }

  async addPreorder() {
    if (!this.currentPreorder || !this.preorderButton) return;
    this.preorderButton.disabled = true;
    const original = this.preorderButton.textContent;
    this.preorderButton.textContent = 'ADDING PRE-ORDER…';
    try {
      const response = await fetch(this.root.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.currentPreorder.id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add preorder');
      window.location.href = '/cart';
    } catch (error) {
      this.preorderButton.disabled = false;
      this.preorderButton.textContent = original;
      console.error(error);
    }
  }

  openNotify() {
    const injected = this.notifyPortal?.querySelector('.restock-alerts-notify-button, .PRODUCT_PAGE_notify-button');
    if (injected) { injected.click(); return; }
    const variantId = this.currentVariant?.id;
    const productUrl = this.root.dataset.productUrl;
    if (productUrl) window.location.href = `${productUrl}${variantId ? `?variant=${variantId}` : ''}`;
  }

  handleStickyAction() {
    if (!this.currentVariant || !this.isSoldOut(this.currentVariant)) { this.addButton.click(); return; }
    if (this.currentPreorder) this.addPreorder();
    else this.openNotify();
  }

  updateMedia(variant) {
    let media = this.mediaById[String(variant.id)];

    if (this.colorOptionIndex >= 0) {
      const selectedColor = variant.options[this.colorOptionIndex];

      if ((!media || !media.src) && this.colorMedia[selectedColor] && this.colorMedia[selectedColor].src) {
        media = this.colorMedia[selectedColor];
      }

      if (!media || !media.src) {
        const sibling = this.variants.find((item) => {
          const itemMedia = this.mediaById[String(item.id)];
          return item.options[this.colorOptionIndex] === selectedColor && itemMedia && itemMedia.src;
        });
        if (sibling) media = this.mediaById[String(sibling.id)];
      }
    }

    if (this.purchaseImage) {
      this.purchaseImage.removeAttribute('srcset');
      this.purchaseImage.removeAttribute('sizes');
      this.purchaseImage.src = media && media.src ? media.src : this.purchaseFallbackSrc;
      if (media && media.alt) this.purchaseImage.alt = media.alt;
    }

    if (this.stickyImage) {
      this.stickyImage.removeAttribute('srcset');
      this.stickyImage.removeAttribute('sizes');
      this.stickyImage.src = media && media.stickySrc ? media.stickySrc : this.stickyFallbackSrc;
      if (media && media.alt) this.stickyImage.alt = media.alt;
    }
  }

  selectColor(colorName) {
    if (this.colorOptionIndex < 0 || !colorName) return;
    const colorGroup = this.optionGroups[this.colorOptionIndex];
    const input = [...colorGroup.querySelectorAll('[data-lb-option-input]')].find((item) => item.value === colorName);
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    this.root.querySelector(`#LBPurchase-${this.root.dataset.sectionId}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  initStickyObserver() {
    if (!this.sticky || !this.purchaseSection || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const belowPurchase = entry.boundingClientRect.bottom < 0;
      this.sticky.classList.toggle('is-visible', belowPurchase && !entry.isIntersecting);
    }, { threshold: 0.05 });
    observer.observe(this.purchaseSection);
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: Shopify.currency.active }).format(cents / 100);
  }
}

document.querySelectorAll('[id^="LBInstagramLanding-"]').forEach((root) => {
  root.dataset.addText = root.querySelector('[data-lb-add-text]')?.textContent?.trim() || 'Add to cart';
  root.dataset.soldText = 'Sold out';
  new LBLandingProduct(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ladybird-lfv2-shop"] && !Shopify.designMode) return;
  try {
    

class LBLongformV2Product {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-lb-product-form]');
    if (!this.form) return;
    this.variantInput = this.form.querySelector('[data-lb-variant-id]');
    this.addButton = this.form.querySelector('[data-lb-add]');
    this.addText = this.form.querySelector('[data-lb-add-text]');
    this.price = root.querySelector('[data-lb-price]');
    this.stickyPrice = root.querySelector('[data-lb-sticky-price]');
    this.stickyAdd = root.querySelector('[data-lb-sticky-add]');
    this.purchaseImage = root.querySelector('.lfv2-purchase__image');
    this.stickyImage = root.querySelector('.lfv2-sticky__image');
    this.sticky = root.querySelector('[data-lb-sticky]');
    this.purchaseMedia = root.querySelector('[data-lb-purchase-media]');
    this.purchaseSection = root.querySelector('[data-lb-purchase]');
    this.selectedColorLabel = root.querySelector('[data-lb-selected-color]');
    this.colorCards = [];
    this.handleColorCardClick = (event) => { const card = event.target.closest('.lfv2-colors [data-lb-color-card]'); if (card) this.selectColor(card.dataset.colorName); };
    document.addEventListener('click', this.handleColorCardClick);
    this.soldoutState = root.querySelector('[data-lb-soldout-state]');
    this.soldoutTitle = root.querySelector('[data-lb-soldout-title]');
    this.soldoutHelper = root.querySelector('[data-lb-soldout-helper]');
    this.preorderButton = root.querySelector('[data-lb-preorder-button]');
    this.notifyPortal = root.querySelector('[data-lb-notify-portal]');
    this.notifyFallback = root.querySelector('[data-lb-notify-fallback]');
    this.purchaseFallbackSrc = this.purchaseImage ? this.purchaseImage.currentSrc || this.purchaseImage.src : null;
    this.stickyFallbackSrc = this.stickyImage ? this.stickyImage.currentSrc || this.stickyImage.src : null;
    this.variants = JSON.parse(this.form.querySelector('[data-lb-variants]').textContent);
    this.variantState = JSON.parse(this.form.querySelector('[data-lb-variant-state]').textContent);
    this.stateById = Object.fromEntries(this.variantState.map((item) => [String(item.id), item]));
    this.preorderVariants = JSON.parse(this.form.querySelector('[data-lb-preorder-variants]').textContent);
    this.variantMedia = JSON.parse(this.form.querySelector('[data-lb-variant-media]').textContent);
    this.mediaById = Object.fromEntries(this.variantMedia.map((item) => [String(item.id), item]));
    this.colorMedia = JSON.parse(this.form.querySelector('[data-lb-color-media]').textContent);
    this.optionGroups = [...this.form.querySelectorAll('[data-lb-option]')];
    this.colorOptionIndex = this.optionGroups.findIndex((group) => /colou?r/i.test(group.querySelector('legend')?.textContent || ''));
    this.form.addEventListener('change', () => this.onChange());
    if (this.stickyAdd) this.stickyAdd.addEventListener('click', () => this.handleStickyAction());
    if (this.preorderButton) this.preorderButton.addEventListener('click', () => this.addPreorder());
    if (this.notifyFallback) this.notifyFallback.addEventListener('click', () => this.openNotify());
    this.colorCards.forEach((card) => card.addEventListener('click', () => this.selectColor(card.dataset.colorName)));
    this.initGallery();
    this.initStickyObserver();
    this.onChange();
  }

  selectedOptions() {
    return [...this.form.querySelectorAll('[data-lb-option]')].map((group) => {
      const selected = group.querySelector('[data-lb-option-input]:checked');
      return selected ? selected.value : null;
    });
  }

  onChange() {
    const selected = this.selectedOptions();
    const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    this.variantInput.value = variant.id;
    const formatted = this.formatMoney(variant.price);
    if (this.price) this.price.textContent = formatted;
    if (this.stickyPrice) this.stickyPrice.textContent = formatted;
    this.updateMedia(variant);
    if (this.colorOptionIndex >= 0 && this.selectedColorLabel) this.selectedColorLabel.textContent = variant.options[this.colorOptionIndex];
    this.updateAvailability(variant);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  isSoldOut(variant) {
    const state = this.stateById[String(variant.id)];
    if (!state) return !variant.available;
    const handle = this.root.dataset.productUrl || '';
    if (handle.includes('birdie-shirt')) return Number(state.inventory) <= 0;
    return state.available === false && Number(state.inventory) <= 0;
  }

  sizeName(size) {
    return ({ XS: 'Extra Small', S: 'Small', M: 'Medium', L: 'Large', XL: 'Extra Large' })[size] || size;
  }

  findPreorder(variant) {
    return this.preorderVariants.find((item) => item.available && item.options.every((value, index) => value === variant.options[index]));
  }

  updateSizeStates(variant) {
    const sizeIndex = this.optionGroups.findIndex((group) => /size/i.test(group.querySelector('legend')?.textContent || ''));
    if (sizeIndex < 0) return;
    const sizeGroup = this.optionGroups[sizeIndex];
    [...sizeGroup.querySelectorAll('[data-lb-option-input]')].forEach((input) => {
      const wanted = [...variant.options];
      wanted[sizeIndex] = input.value;
      const candidate = this.variants.find((item) => item.options.every((value, index) => value === wanted[index]));
      input.dataset.lbSoldout = candidate && this.isSoldOut(candidate) ? 'true' : 'false';
    });
  }

  updateAvailability(variant) {
    this.currentVariant = variant;
    this.updateSizeStates(variant);
    const soldOut = this.isSoldOut(variant);
    const preorder = soldOut ? this.findPreorder(variant) : null;
    this.currentPreorder = preorder || null;
    this.addButton.hidden = soldOut;
    this.addButton.disabled = soldOut || !variant.available;
    this.addText.textContent = this.root.dataset.addText || 'Add to cart';
    if (this.soldoutState) this.soldoutState.hidden = !soldOut;
    if (soldOut && this.soldoutTitle) {
      const size = variant.options.find((value, index) => /size/i.test(this.optionGroups[index]?.querySelector('legend')?.textContent || '')) || variant.options[1];
      this.soldoutTitle.textContent = `Size ${this.sizeName(size)} is currently out of stock`;
    }
    if (this.preorderButton) this.preorderButton.hidden = !preorder;
    if (this.soldoutHelper) this.soldoutHelper.hidden = !preorder;
    if (this.stickyAdd) {
      this.stickyAdd.textContent = soldOut ? (preorder ? 'Pre-order' : 'Notify me') : (this.root.dataset.addText || 'Add to cart');
    }
  }

  async addPreorder() {
    if (!this.currentPreorder || !this.preorderButton) return;
    this.preorderButton.disabled = true;
    const original = this.preorderButton.textContent;
    this.preorderButton.textContent = 'ADDING PRE-ORDER…';
    try {
      const response = await fetch(this.root.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.currentPreorder.id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add preorder');
      window.location.href = '/cart';
    } catch (error) {
      this.preorderButton.disabled = false;
      this.preorderButton.textContent = original;
      console.error(error);
    }
  }

  openNotify() {
    const injected = this.notifyPortal?.querySelector('.restock-alerts-notify-button, .PRODUCT_PAGE_notify-button');
    if (injected) { injected.click(); return; }
    const variantId = this.currentVariant?.id;
    const productUrl = this.root.dataset.productUrl;
    if (productUrl) window.location.href = `${productUrl}${variantId ? `?variant=${variantId}` : ''}`;
  }

  handleStickyAction() {
    if (!this.currentVariant || !this.isSoldOut(this.currentVariant)) { this.addButton.click(); return; }
    if (this.currentPreorder) this.addPreorder();
    else this.openNotify();
  }

  updateMedia(variant) {
    let media = this.mediaById[String(variant.id)];

    if (this.colorOptionIndex >= 0) {
      const selectedColor = variant.options[this.colorOptionIndex];

      if ((!media || !media.src) && this.colorMedia[selectedColor] && this.colorMedia[selectedColor].src) {
        media = this.colorMedia[selectedColor];
      }

      if (!media || !media.src) {
        const sibling = this.variants.find((item) => {
          const itemMedia = this.mediaById[String(item.id)];
          return item.options[this.colorOptionIndex] === selectedColor && itemMedia && itemMedia.src;
        });
        if (sibling) media = this.mediaById[String(sibling.id)];
      }
    }

    this.buildGallery(variant, media);

    if (this.stickyImage) {
      this.stickyImage.removeAttribute('srcset');
      this.stickyImage.removeAttribute('sizes');
      this.stickyImage.src = media && media.stickySrc ? media.stickySrc : this.stickyFallbackSrc;
      if (media && media.alt) this.stickyImage.alt = media.alt;
    }
  }


  initGallery() {
    this.galleryImages = JSON.parse(this.root.querySelector('[data-lb-gallery-images]')?.textContent || '[]');
    this.gallery = [];
    this.galleryIndex = 0;
    this.galleryColor = null;
    this.galleryPrev = this.root.querySelector('[data-lb-gallery-prev]');
    this.galleryNext = this.root.querySelector('[data-lb-gallery-next]');
    this.galleryCount = this.root.querySelector('[data-lb-gallery-count]');
    if (!this.purchaseMedia || !this.purchaseImage) return;
    this.purchaseImage.draggable = false;
    this.purchaseMedia.tabIndex = 0;
    this.purchaseMedia.setAttribute('role', 'region');
    this.purchaseMedia.setAttribute('aria-label', this.root.dataset.galleryLabel);
    this.galleryPrev?.addEventListener('click', () => this.stepGallery(-1));
    this.galleryNext?.addEventListener('click', () => this.stepGallery(1));
    this.purchaseMedia.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.stepGallery(event.key === 'ArrowLeft' ? -1 : 1);
    });
    this.purchaseMedia.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      this.galleryPointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
      this.purchaseMedia.setPointerCapture(event.pointerId);
      this.purchaseMedia.classList.add('is-dragging');
    });
    this.purchaseMedia.addEventListener('pointerup', (event) => {
      const start = this.galleryPointer;
      this.galleryPointer = null;
      this.purchaseMedia.classList.remove('is-dragging');
      if (!start || start.id !== event.pointerId) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.25) this.stepGallery(dx > 0 ? -1 : 1);
    });
    const cancel = () => { this.galleryPointer = null; this.purchaseMedia.classList.remove('is-dragging'); };
    this.purchaseMedia.addEventListener('pointercancel', cancel);
    this.purchaseMedia.addEventListener('lostpointercapture', cancel);
  }

  galleryKey(src) {
    if (!src) return '';
    return new URL(src, window.location.origin).pathname.replace(/_(\d+x\d*|\d+x)(?=\.[a-z0-9]+$)/i, '').toLowerCase();
  }

  galleryTokens(color) {
    const normalized = String(color || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    return ({ 'burnt orange': ['burnt orange', 'orange'], 'hot pink': ['hot pink', 'pink'], hunter: ['hunter', 'green'], khaki: ['khaki', 'tan'] })[normalized] || [normalized];
  }

  galleryMatches(item, color) {
    const filename = this.galleryKey(item.src).split('/').pop();
    const text = ` ${filename} ${item.alt || ''} `.toLowerCase().replace(/[^a-z0-9]+/g, ' ');
    return this.galleryTokens(color).some((token) => token && text.includes(` ${token} `));
  }

  buildGallery(variant, media) {
    if (!this.purchaseImage) return;
    const color = this.colorOptionIndex >= 0 ? variant.options[this.colorOptionIndex] : '';
    if (this.galleryColor === color && this.gallery.length) return;
    const mainSrc = media?.src || this.purchaseFallbackSrc;
    const mainKey = this.galleryKey(mainSrc);
    const main = this.galleryImages.find((item) => this.galleryKey(item.src) === mainKey) || { src: mainSrc, alt: media?.alt || this.purchaseImage.alt };
    const matching = this.galleryImages.filter((item) => !color || this.galleryMatches(item, color));
    const seen = new Set();
    this.gallery = [main, ...matching].filter((item) => {
      const key = this.galleryKey(item.src);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    this.galleryColor = color;
    this.galleryIndex = 0;
    this.renderGallery();
  }

  renderGallery() {
    const item = this.gallery[this.galleryIndex];
    if (!item || !this.purchaseImage) return;
    this.purchaseImage.removeAttribute('srcset');
    this.purchaseImage.removeAttribute('sizes');
    this.purchaseImage.src = item.src;
    this.purchaseImage.alt = item.alt || '';
    if (item.width && item.height) {
      this.purchaseImage.width = item.width;
      this.purchaseImage.height = item.height;
    } else {
      this.purchaseImage.removeAttribute('width');
      this.purchaseImage.removeAttribute('height');
    }
    const multi = this.gallery.length > 1;
    if (this.galleryPrev) this.galleryPrev.hidden = !multi;
    if (this.galleryNext) this.galleryNext.hidden = !multi;
    if (this.galleryCount) {
      this.galleryCount.hidden = !multi;
      this.galleryCount.textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
    }
  }

  stepGallery(delta) {
    if (this.gallery.length < 2) return;
    this.galleryIndex = (this.galleryIndex + delta + this.gallery.length) % this.gallery.length;
    this.renderGallery();
  }

  destroy() {
    document.removeEventListener('click', this.handleColorCardClick);
    this.stickyObserver?.disconnect();
  }

  selectColor(colorName) {
    if (this.colorOptionIndex < 0 || !colorName) return;
    const colorGroup = this.optionGroups[this.colorOptionIndex];
    const input = [...colorGroup.querySelectorAll('[data-lb-option-input]')].find((item) => item.value === colorName);
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    this.root.querySelector(`#LBPurchase-${this.root.dataset.sectionId}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  initStickyObserver() {
    if (!this.sticky || !this.purchaseSection || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const belowPurchase = entry.boundingClientRect.bottom < 0;
      this.sticky.classList.toggle('is-visible', belowPurchase && !entry.isIntersecting);
    }, { threshold: 0.05 });
    observer.observe(this.purchaseSection);
    this.stickyObserver = observer;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: Shopify.currency.active }).format(cents / 100);
  }
}

const lbLongformV2Instances = new WeakMap();
function initLBLongformV2(scope = document) {
  scope.querySelectorAll('[id^="LBLongformV2-"]').forEach((root) => {
    if (lbLongformV2Instances.has(root)) return;
    root.dataset.addText = root.querySelector('[data-lb-add-text]')?.textContent?.trim() || 'Add to cart';
    root.dataset.soldText = 'Sold out';
    lbLongformV2Instances.set(root, new LBLongformV2Product(root));
  });
}
initLBLongformV2();
document.addEventListener('shopify:section:load', (event) => initLBLongformV2(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[id^="LBLongformV2-"]').forEach((root) => {
    lbLongformV2Instances.get(root)?.destroy();
    lbLongformV2Instances.delete(root);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-custom-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const focusResult = (root) => {
    const result = root.querySelector('.lbc-success, .lbc-errors');
    if (result) { result.setAttribute('tabindex', '-1'); result.focus({preventScroll:true}); result.scrollIntoView({block:'center'}); }
  };
  if (!window.Shopify?.designMode) focusResult(document);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-lbc-quote]');
    if (!link) return;
    const target = document.getElementById('custom-quote');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    const field = target.querySelector('input:not([type="hidden"])');
    if (field) field.focus({preventScroll:true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbs-judge-me-reviews"] && !Shopify.designMode) return;
  try {
    

const initializeLbsReviews = (section) => {

  if (
    !section ||
    section.dataset.lbsInitialized === 'true'
  ) {
    return;
  }


  section.dataset.lbsInitialized = 'true';


  const trigger =
    section.querySelector(
      '[data-lbs-write-review]'
    );


  const nativeWidget =
    section.querySelector(
      '[data-lbs-native]'
    );


  if (!trigger || !nativeWidget) {
    return;
  }


  trigger.addEventListener(
    'click',
    () => {

      section.classList.add(
        'is-review-form-open'
      );


      const clickJudgeMeButton = () => {

        const directTarget =
          nativeWidget.querySelector(
            '.jdgm-write-rev-link, [data-testid="write-review-button"], [data-testid*="write-review"]'
          );


        if (directTarget) {

          directTarget.click();

          return true;
        }


        const textTarget =
          Array
            .from(
              nativeWidget.querySelectorAll(
                'button, a'
              )
            )
            .find(
              (element) =>
                /write\s+(a\s+)?review/i.test(
                  element.textContent || ''
                )
            );


        if (textTarget) {

          textTarget.click();

          return true;
        }


        return false;
      };


      if (clickJudgeMeButton()) {
        return;
      }


      let attempts = 0;


      const timer =
        window.setInterval(
          () => {

            attempts += 1;


            if (
              clickJudgeMeButton() ||
              attempts >= 20
            ) {

              window.clearInterval(timer);


              if (attempts >= 20) {

                nativeWidget.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });

              }

            }

          },
          150
        );

    }
  );

};


document
  .querySelectorAll(
    '[data-lbs-reviews]'
  )
  .forEach(
    initializeLbsReviews
  );


document.addEventListener(
  'shopify:section:load',
  (event) => {

    const section =
      event.target.matches(
        '[data-lbs-reviews]'
      )
        ? event.target
        : event.target.querySelector(
            '[data-lbs-reviews]'
          );


    initializeLbsReviews(section);

  }
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
